// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"622":"847de69d","677":"3e661352"}[chunkId] + ".css";
};